var DEFAULT_OPT = {
    'url': '',
    'charset': 'UTF-8',
    'timeout': 30 * 1000,
    'data': {},
    'argsType': 'query',
    'method': 'get',
    'headers': {},
    'isEncode': false,
    'dataType': 'json',
    'cache': false,
    'withCredentials': false,
    'jsonp': 'callback',
    'jsonpCallback': '',
    'defaultProtocolInFile': 'https',
    'success': function success() {},
    'error': function error() {},
    'onTimeout': function onTimeout() {},
    'onAbort': function onAbort() {}
};

var doc = document;
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var isString = function isString(obj) {
    return typeof obj === 'string';
};
var isArray = function isArray(obj) {
    return Object.prototype.toString(obj) === '[object Array]';
};
var notNull = function notNull(v) {
    return !(v === null || v === void 0);
};
var parseURL = require('../../qunar/util/parseUrl');
var extend = require('../../../src/util/extend');

var format = function format(data, isEncode) {
    data = (data === null ? '' : data).toString().trim();
    return isEncode ? encodeURIComponent(data) : data;
};

var jsonToQuery = function jsonToQuery(json, isEncode) {
    var qs = [],
        k = void 0,
        i = void 0,
        len = void 0;
    for (k in json) {
        if (json.hasOwnProperty(k)) {
            if (k === '$nullName') {
                qs = qs.concat(json[k]);
            } else if (isArray(json[k])) {
                for (i = 0, len = json[k].length; i < len; i++) {
                    if (!isFunction(json[k][i])) {
                        qs.push(k + "=" + format(json[k][i], isEncode));
                    }
                }
            } else if (!isFunction(json[k]) && notNull(json[k])) {
                qs.push(k + "=" + format(json[k], isEncode));
            }
        }
    }
    return qs.join('&');
};

var getXMLHttpRequest = function getXMLHttpRequest() {
    var xhr = false;
    try {
        xhr = new XMLHttpRequest();
    } catch (try_MS) {
        try {
            xhr = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (other_MS) {
            try {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (failed) {
                xhr = false;
            }
        }
    }
    return xhr;
};

var setRequestHeader = function setRequestHeader(trans, headers) {
    try {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                trans.setRequestHeader(key, headers[key]);
            }
        }
    } catch (e) {}
};

var reqFilters = [],
    respFilters = [],
    jsonpExtraStamp = 0;

var doRequest = function doRequest(options, listener) {
    var trans = getXMLHttpRequest(),
        timeout = void 0,
        argsString = '',
        method = options.method.toLocaleLowerCase(),
        scriptElem = doc.createElement('script'),
        url = void 0,
        urlObj = void 0;

    scriptElem.src = options.url;

    urlObj = parseURL(scriptElem.src);

    if (urlObj.protocol === 'file') {
        urlObj.protocol = options.defaultProtocolInFile;
    }

    url = urlObj.toUrl();

    if (options.withCredentials) {
        trans.withCredentials = true;
    }

    if (options.timeout) {
        timeout = setTimeout(function () {
            listener(null, {
                error: true,
                type: 'Timeout'
            });
            trans.abort();
        }, options.timeout);
    }

    var isAborted = false,
        _abort = trans.abort;

    trans.abort = function () {
        isAborted = true;
        _abort.call(trans);

        listener(null, {
            error: true,
            type: 'Abort'
        });
    };

    trans.onreadystatechange = function () {

        if (trans.readyState === 4) {
            clearTimeout(timeout);
            var data = {};
            if (options.dataType === 'xml') {
                data = trans.responseXML;
            } else if (options.dataType === 'json') {
                data = trans.responseText && typeof trans.responseText === 'string' ? JSON.parse(trans.responseText) : {};
            } else {
                data = trans.responseText;
            }
            if (trans.status === 200) {
                listener(data);
            } else if (trans.status === 0) {
                // 如果不是手动 abort 的
                if (!isAborted) {
                    // 无网络
                    listener(null, {
                        error: true,
                        type: 'Fail'
                    });
                }
            } else {
                listener(null, {
                    error: true,
                    type: 'Fail'
                });
            }
        }
    };

    if (method === 'get') {
        if (options.cache === false) {
            options.data.__rnd = new Date().getTime();
        }
    }

    if (options.argsType === 'query') {
        argsString = jsonToQuery(options.data, options.isEncode);
    } else if (options.argsType === 'json') {
        argsString = JSON.stringify(options.data);
        if (options.isEncode) {
            argsString = encodeURIComponent(argsString);
        }
    }

    // 设置 Content-Type
    if (!options.headers['Content-Type']) {
        // 如果用户未定义
        if (options.argsType === 'json') {
            // 如果用户设置请求数据格式为 json
            options.headers['Content-Type'] = 'application/json;charset=' + options.charset;
        } else {
            options.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=' + options.charset;
        }
    }
    // 设置 X-Requested-With
    if (!options.headers['X-Requested-With']) {
        options.headers['X-Requested-With'] = 'XMLHttpRequest';
    }

    if (method === 'get') {
        if (argsString) {
            url = url + (!~url.indexOf('?') ? '?' : '&') + argsString;
        } else {
            url = url;
        }
        trans.open('get', url, true);
        setRequestHeader(trans, options.headers);
        trans.send('');
    } else {
        trans.open('post', url, true);
        setRequestHeader(trans, options.headers);
        trans.send(argsString);
    }

    return trans;
};

var doJsonp = function doJsonp(options, listener) {

    var trans = {},
        isCanceled = false,
        // 是否被取消
    callbackName = '',
        // 回调函数名
    overwritten = void 0,
        // 用户回调函数寄存
    hasSetCallbackName = false,
        // 用户是否设置回调函数名
    scriptElem = doc.createElement('script'),
        timer = void 0;

    scriptElem.src = options.url;

    var URL = parseURL(scriptElem.src);

    if (URL.protocol === 'file') {
        URl.protocol = options.defaultProtocolInFile;
    }

    URL.query = extend(URL.query, options.data);

    if (options.jsonpCallback) {
        // 如果用户设置了回调函数名
        hasSetCallbackName = true;
        // 寄存回调函数
        overwritten = global[options.jsonpCallback];
    } else {
        // 如果用户没有设置回调函数名，生成随机函数名
        options.jsonpCallback = 'HySDK_' + +new Date() + jsonpExtraStamp++;
    }
    callbackName = options.jsonpCallback;
    URL.query[options.jsonp] = callbackName;

    /**
     * cache 处理
     * 默认为 false
     */
    if (options.cache === false) {
        // 唯一数字戳
        URL.query.__rnd = +new Date() + jsonpExtraStamp++;
    }

    /**
     * 各种回调结束后的现场恢复函数
     */
    var backingOut = function backingOut() {
        // 回调函数处理
        if (hasSetCallbackName) {
            // 如果回调函数是用户设置，恢复
            global[callbackName] = overwritten;
        } else {
            // 如果回调函数不是用户设置，销毁
            delete global[callbackName];
        }
        // script 元素删除
        scriptElem.remove();
    };

    /**
     * abort 方法
     */
    trans.abort = function () {
        isCanceled = true;

        listener(null, {
            error: true,
            type: 'Abort'
        });
        backingOut();
    };

    global[callbackName] = function (data) {
        if (timer) {
            clearTimeout(timer);
        }

        if (isCanceled) {
            return;
        }

        listener(data);
        backingOut();
    };

    timer = setTimeout(function () {
        listener(null, {
            error: true,
            type: 'Timeout'
        });
        backingOut();
    }, options.timeout);

    /**
     * 插入 script 元素
     */
    // 创建 script 元素
    scriptElem.async = true;
    scriptElem.charset = options.charset;
    scriptElem.src = URL.toUrl();
    // script 元素事件绑定
    scriptElem.onerror = function () {
        if (timer) {
            clearTimeout(timer);
        }

        listener(null, {
            error: true,
            type: 'Fail'
        });
        backingOut();
    };

    // 强势插入
    doc.head.appendChild(scriptElem);

    return trans;
};

var ajax = module.exports = function (options) {
    if (isString(options)) {
        options = {
            url: options
        };
    }

    var opt = extend(true, {}, DEFAULT_OPT, options),
        trans = {},
        flag = true,
        listener = function listener(data, err) {
        var flag = true;

        respFilters.forEach(function (filter) {
            if (filter(opt) === false) {
                flag = false;
            }
        });

        if (flag) {
            if (err) {
                if (err.type === 'Timeout') {
                    opt.onTimeout(data, trans);
                } else if (err.type === 'Abort') {
                    opt.onAbort(data, trans);
                } else {
                    opt.error(data, trans);
                }
            }
        }
    };

    reqFilters.forEach(function (filter) {
        if (filter(opt, listener) === false) {
            flag = false;
        }
    });

    if (flag) {
        if (options.dataType === 'jsonp') {
            trans = doJsonp(opt, listener);
        } else {
            trans = doRequest(opt, listener);
        }
    }

    return trans;
};

ajax.addReqFilter = function (filter) {
    reqFilters = reqFilters.concat(filter);
};

ajax.removeReqFilter = function (filter) {
    var index = reqFilters.indexOf(filter);
    if (index > -1) {
        reqFilters.splice(index, 1);
    }
};

ajax.addRespFilter = function (filter) {
    respFilters = respFilters.concat(filter);
};

ajax.removeRespFilter = function (filter) {
    var index = respFilters.indexOf(filter);
    if (index > -1) {
        respFilters.splice(index, 1);
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/util/ajax.js
// module id = 56
// module chunks = 1 4